import { api, request, type TokenPair } from '../api/client'
import { tokens } from './tokens'

export type Me = {
  id: string
  email: string
  first_name: string
  last_name: string
  phone?: string
  /** Bağlı personel; varsa ad, soyad ve e-posta İK kaydından yönetilir. */
  employee_id?: string | null
  avatar_url?: string
  permissions?: string[]
  region_id?: string
  roles: { id: string; name: string }[]
  must_change_password: boolean
  /** Rol değişince zorunlu çıkış zamanı (ISO). */
  session_end_at?: string | null
}

export type ProfileInput = { first_name: string; last_name: string; phone: string; email: string; current_password?: string }

export const authApi = {
  /** Güvenilen cihaz belirteci geçerliyse `session` döner (OTP adımı atlanır); değilse `pre_auth_token`. */
  login: (email: string, password: string, deviceToken?: string) =>
    api.public<{ pre_auth_token?: string; expires_in?: number; message: string; session?: TokenPair }>('POST', '/api/v1/auth/login', {
      email,
      password,
      device_token: deviceToken || undefined,
    }),
  verifyOtp: (preAuthToken: string, otp: string, rememberDevice = false) =>
    api.public<TokenPair>('POST', '/api/v1/auth/verify-otp', { pre_auth_token: preAuthToken, otp, remember_device: rememberDevice }),
  me: () => api.get<Me>('/api/v1/auth/me'),
  // Rol değişiminde sunucu oturumu kapatmış olabilir; 401 burada yeniden "oturum sonlandı" akışı başlatmamalı.
  logout: (refreshToken: string) => request<void>('POST', '/api/v1/auth/logout', { body: { refresh_token: refreshToken }, quietAuth: true }),
  updateProfile: (body: ProfileInput) => api.put<Me>('/api/v1/auth/profile', body),
  /** 1. adım: mevcut parola doğrulanır, e-postaya kod gider. */
  requestPasswordOtp: (current_password: string, new_password: string) =>
    api.post<{ pre_auth_token: string; expires_in: number; message: string }>('/api/v1/auth/change-password/request-otp', { current_password, new_password }),
  /** 2. adım: kod + yeni parola; başarıda tüm oturumlar kapanır. */
  changePassword: (pre_auth_token: string, otp: string, new_password: string) =>
    api.put<void>('/api/v1/auth/change-password', { pre_auth_token, otp, new_password }),
  forgotPassword: (email: string) =>
    api.public<{ message: string; expires_in?: number }>('POST', '/api/v1/auth/forgot-password', { email }),
  resetPassword: (pre_auth_token: string, otp: string, new_password: string) =>
    api.public<void>('POST', '/api/v1/auth/reset-password', { pre_auth_token, otp, new_password }),
  csrf: async () => {
    const data = await api.get<{ csrf_token: string }>('/api/v1/auth/csrf')
    if (data?.csrf_token) tokens.setCsrf(data.csrf_token)
    return data
  },
}
